const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export const GetCursos = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/metadata/cursos`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        if (response.ok) {
            return await response.json();
        }
        return [];
    } catch (e) {
        console.error(e);
        return [];
    }
};

export const PostCurs = async (parentId: number | null, value: string, label: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/metadata/cursos`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ parent_id: parentId, value, label }),
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const PutCurs = async (id: number, label: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/metadata/cursos`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ id, label }),
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const DeleteCurs = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/metadata/cursos/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
};
